<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      height="2"
      class="mb-2" />
    <v-simple-table dense>
      <thead>
        <tr>
          <th>Month</th>
          <!-- <th>Tent PCS</th>
          <th>Prod PCS</th> -->
          <th>สินค้าตัวอย่าง</th>
          <th>สินค้าสำหรับขาย</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, i) in localRows"
          :key="i">
          <td
            class="text-caption"
            style="padding: 6px 8px;">
            {{ formatMonth(row.year, row.month) }}
            <v-chip
              v-if="row.isOverride"
              x-small
              color="blue lighten-4"
              text-color="blue darken-3"
              class="ml-1">
              override
            </v-chip>
          </td>
          <!-- <td style="padding: 6px 8px;">
            <v-text-field
              v-model.number="row.tentPcs"
              type="number"
              placeholder="800"
              dense
              hide-details="auto"
              :rules="positiveIntRules"
              style="max-width: 90px;"
              @input="row.isOverride = true" />
          </td>
          <td style="padding: 6px 8px;">
            <v-text-field
              v-model.number="row.prodPcs"
              type="number"
              placeholder="800"
              dense
              hide-details="auto"
              :rules="positiveIntRules"
              style="max-width: 90px;"
              @input="row.isOverride = true" />
          </td> -->
          <td style="padding: 6px 8px;">
            <v-text-field
              v-model.number="row.tentProd"
              type="number"
              placeholder="8"
              dense
              hide-details="auto"
              :rules="positiveIntRules"
              style="max-width: 90px;"
              @input="row.isOverride = true" />
          </td>
          <td style="padding: 6px 8px;">
            <v-text-field
              v-model.number="row.prodProd"
              type="number"
              placeholder="8"
              dense
              hide-details="auto"
              :rules="positiveIntRules"
              style="max-width: 90px;"
              @input="row.isOverride = true" />
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'CapacityOverrideTable',
  props: {
    overrides: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      localRows: [],
      positiveIntRules: [
        (v) => v == null || v === '' || (Number.isInteger(v) && v >= 0) || 'Must be 0 or a positive integer'
      ]
    }
  },
  watch: {
    overrides: {
      immediate: true,
      handler (val) {
        this.localRows = this.buildMonthGrid(val)
      }
    }
  },
  methods: {
    buildMonthGrid (overrides) {
      const overrideMap = {}
      overrides.forEach((o) => {
        overrideMap[`${o.year}-${o.month}`] = o
      })
      const now = new Date()
      return Array.from({ length: 12 }, (_, i) => {
        const d = new Date(now.getFullYear(), now.getMonth() + i, 1)
        const year = d.getFullYear()
        const month = d.getMonth() + 1
        const existing = overrideMap[`${year}-${month}`]
        const hasValue = existing && (existing.tentPcs || existing.prodPcs || existing.tentProd || existing.prodProd)
        return hasValue
          ? { ...existing, isOverride: true }
          : { year, month, tentPcs: null, prodPcs: null, tentProd: null, prodProd: null, isOverride: false }
      })
    },
    formatMonth (year, month) {
      return new Date(year, month - 1, 1).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })
    },
    getChangedRows () {
      return this.localRows.filter((r) => r.isOverride)
    }
  }
}
</script>
